import type { MessageKey, ProcessMessage, ProcessMessagePayloadMap } from '~~/common/config/processMessaging';
import { messagePayloadValidators } from '~~/common/config/processMessaging';

export function createProcessMessaging<T extends MessageKey> (
  messageKey: T,
) {
  return {
    send (
      messagePayload: ProcessMessagePayloadMap[T],
    ) {
      if (typeof process === 'object' && process && process.pid && process.send) {
        const message = createProcessMessage(messageKey, messagePayload);
        process.send(message);
      }
    },
  };
}

export function createProcessMessage<T extends MessageKey> (
  messageKey: T,
  messagePayload: ProcessMessagePayloadMap[T],
): ProcessMessage<T> {
  const message = {
    cmd: messageKey,
    pid: process.pid,
    ...messagePayload,
  };
  return message;
}

export function isMatchesProcessMessage<T extends MessageKey> (messageKey: T, msg: unknown): msg is ProcessMessage<T> {
  if (typeof msg === 'object' && msg) {
    const msgObject = msg as Record<string, unknown>;
    // Validate basic structure (cmd and pid)
    if (typeof msgObject.pid === 'number' && typeof msgObject.cmd === 'string') {
      if (msgObject.cmd === messageKey) {
        // Validate payload structure using the appropriate validator
        if (messagePayloadValidators[messageKey]?.(msgObject)) {
          return true;
        }
      }
    }
  }
  return false;
}
